import React, { Component } from 'react';
import { Row, Col, Label, Button } from 'reactstrap';
import ReactDOM from 'react-dom';
import { Redirect } from 'react-router-dom';
import Moment from 'react-moment';
import swal from 'sweetalert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { Document, Page, pdfjs } from 'react-pdf';
import RejectEntriesDropDown from './RejectEntriesDropDown';
import FleetManagerService from '../../../services/FleetManagerService';
import ModalService from '../../../services/ModalService';
import StorageService from '../../../services/Storage';
import ImageAndPDFViewer from "../../../components/ImageAndPDFViewer/ImageAndPDFViewer";
import { Roles } from '../../../constants/constant.role';

pdfjs.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.1.266/pdf.worker.js';
class InvoiceVerificationDetail extends Component {

  constructor(props) {
    super(props);
    const userDetail = StorageService.getUserDetail();
    this.state = {
      redirectToAddEditOfftakeEntry: false,
      editOfftakeEntryQuery: '',
      pageNumber: 1,
      scale: 1,
      imageWidth: 570,
      imageHeight: 590,
      memberRole: userDetail.type
    };
  }

  openViewModal = (data) => {
    this.refs.openViewModal.toggle(data);
  }

  approveClick = () => {
    const { selectedInvoiceForVerification } = this.props;
    ModalService.openAlertWithPopup('', 'Are you sure you want to approve the verification request?', '', ['No', 'Yes'], (isConfirm) => {
      if (isConfirm) {
        this.offtakeStatusUpdate({ id: selectedInvoiceForVerification.uuid, status: 'approved', remark: '', purchaseDate: selectedInvoiceForVerification.purchase_date });
      }
    });
  }

  rejectClick = () => {
    const wrapper = document.createElement('div');
    ReactDOM.render(<RejectEntriesDropDown onRejectMarkYesClick={this.onRejectMarkYesClick} />, wrapper);
    const el = wrapper.firstChild;
    swal({
      text: '',
      content: el,
      buttons: false,
      className: 'send-verify-otp-modal',
      closeOnClickOutside: false,
      closeOEscapeKey: false,
      closeOnConfirm: false
    }).then(value => {
    });
  }

  editOfftakeClick = () => {
    const { selectedInvoiceForVerification } = this.props;
    let { redirectToAddEditOfftakeEntry, editOfftakeEntryQuery } = this.state;
    redirectToAddEditOfftakeEntry = true;
    editOfftakeEntryQuery = {
      uuid: window.btoa(selectedInvoiceForVerification.uuid || ''),
      fleetId: window.btoa(selectedInvoiceForVerification.fleet_id || ''),
    };
    this.setState({ redirectToAddEditOfftakeEntry, editOfftakeEntryQuery });
  }

  onRejectMarkYesClick = (rejectRemark, comment = '') => {
    const { selectedInvoiceForVerification } = this.props;
    this.offtakeStatusUpdate({ id: selectedInvoiceForVerification.uuid, status: 'rejected', remark: rejectRemark, comment });
  }

  offtakeStatusUpdate = async (q) => {
    const { memberRole } = this.state;
    this.props.updateState({ isLoading: true });
    try {
      const obj = {
        id: q.id,
        status: q.status,
        remark: q.remark,
        comment: q.comment
      };

      const { data } = await FleetManagerService.offtakeStatusUpdate(obj);
      if (data.success && (q.status || '').toLowerCase() === 'approved') {
        this.props.updateState({ isLoading: false });
        if (new Date(q.purchaseDate).getTime() <= new Date('2019-08-31T00:00:00.000Z').getTime() && memberRole !== Roles.ZONAL_FLEET_MANAGER_ROLE) {
          ModalService.openAlert('Request approved successfully', 'Note: If purchase date is before 1st Sept, 2019 the request will go through ZFM approval too after your approval.', 'success');
        } else {
          ModalService.openAlert('Request approved successfully', '', 'success');
        }
      } else {
        this.props.updateState({ isLoading: false });
      }
      this.props.updateState({ selectedInvoiceForVerification: {} });
    } catch (error) {
      console.log(error);
    }
  }

  zoomInPDF = () => {
    let { scale } = this.state;
    if (scale > 3) {
      return;
    }

    scale += 0.5;
    this.setState({ scale });
  }

  zoomOutPDF = () => {
    let { scale } = this.state;
    if (scale <= 1) {
      return;
    }
    scale -= 0.5;
    this.setState({ scale });
  }

  zoomInImage = () => {
    let { imageWidth, imageHeight } = this.state;

    if (imageWidth > 1300) {
      return;
    }

    imageWidth += 100;
    imageHeight += 100;
    this.setState({ imageWidth, imageHeight });
  }

  zoomOutImage = () => {
    let { imageWidth, imageHeight } = this.state;
    if (imageWidth <= 570) {
      return;
    }
    imageWidth -= 100;
    imageHeight -= 100;
    this.setState({ imageWidth, imageHeight });
  }

  render() {
    const { selectedInvoiceForVerification } = this.props;
    const { redirectToAddEditOfftakeEntry, editOfftakeEntryQuery } = this.state;
    const { pageNumber, scale, 
      // imageHeight, 
      // imageWidth 
    } = this.state;
    return (
      <div>
        {redirectToAddEditOfftakeEntry && <Redirect to={{ pathname: '/addEditOfftakeEntry', search: `uuid=${editOfftakeEntryQuery.uuid}&fleetId=${editOfftakeEntryQuery.fleetId}` }} />}
        <Row>
          <Col>
            <div className="offtake-title" style={{ fontSize: '16px', marginTop: '13px', display: 'flex' }}>
              <span style={{ marginTop: '1px' }}>INVOICE DETAILS</span>
              {
                selectedInvoiceForVerification.invoice_number && this.props.from !== 'indirectBilling' &&
                <FontAwesomeIcon title="Edit" onClick={this.editOfftakeClick} icon={faPen} style={{ color: '#fdbb1f', marginLeft: '12px', cursor: 'pointer' }} />
              }
            </div>
          </Col>
          <Col>
            {
              selectedInvoiceForVerification.invoice_number && this.props.from !== 'indirectBilling' &&
              <div className="pull-right">
                <Button className="mb-1 mr-1 btn-pill action-button c-danger-btn" color="danger" onClick={this.rejectClick}>Reject</Button>
                <Button className="mb-1 mr-1 btn-pill action-button c-success-btn" color="success" onClick={this.approveClick}>Approve</Button>
              </div>
            }
          </Col>
        </Row>

        <Row>
          <Col>
            <hr />
          </Col>
        </Row>

        {
          !selectedInvoiceForVerification.invoice_number &&
          <Row className="c-top-12">
            <Col>
              <span className="click-on-the-fleet-name">
                {
                  this.props.from !== 'indirectBilling' ?
                    'Click on the fleet name to view its deatils and verify it.'
                    :
                    'Click on the fleet name to view its deatils.'

                }
              </span>
            </Col>
          </Row>
        }

        {
          selectedInvoiceForVerification.invoice_number &&
          <>
            {
              this.props.from !== 'indirectBilling' &&
              <Row>
                <Col className="fm-instruction">
                  Note:  Please approve only valid invoices, issued by JK Authorized dealers.
                        Other documents like challan, tyre purchase lists should be rejected.
                </Col>
              </Row>
            }
            <Row style={{ marginTop: '15px' }}>
              <Col xl="4" md="4" xs="12" sm="12">
                <Label className="invoice-label-right">Invoice Number</Label>
                <div className="invoice-value-right">{selectedInvoiceForVerification.invoice_number}</div>
              </Col>
              <Col xl="4" md="4" xs="12" sm="12">
                <Label className="invoice-label-right">Purchase Date</Label>
                <div className="invoice-value-right">
                  <Moment format="DD MMM YYYY">
                    {selectedInvoiceForVerification.purchase_date}
                  </Moment>
                  {/* {selectedInvoiceForVerification.purchasedDate} */}
                </div>
              </Col>
              <Col xl="4" md="4" xs="12" sm="12">
                <Label className="invoice-label-right">Submission Date</Label>
                <div className="invoice-value-right">
                  <Moment format="DD MMM YYYY">
                    {selectedInvoiceForVerification.created_at}
                  </Moment>
                </div>
              </Col>
            </Row>
            <Row className="c-top-15">
              <Col xl="4" md="4" xs="12" sm="12">
                <Label className="invoice-label-right">Fleet Name</Label>
                <div className="invoice-value-right">{selectedInvoiceForVerification.fleet}</div>
              </Col>
              <Col xl="4" md="4" xs="12" sm="12">
                <Label className="invoice-label-right">Dealer Name</Label>
                <div className="invoice-value-right">{selectedInvoiceForVerification.dealer_name}</div>
              </Col>
              <Col xl="4" md="4" xs="12" sm="12">
                <Label className="invoice-label-right">Invoice in favour of</Label>
                <div className="invoice-value-right">{selectedInvoiceForVerification.subsidiary_name}</div>
              </Col>
            </Row>

            {
              <Row className="c-top-15">
                {
                  selectedInvoiceForVerification.comment && <Col xl="4" md="4" xs="12" sm="12">
                    <Label className="invoice-label-right">Comment</Label>
                    <div className="invoice-value-right">{selectedInvoiceForVerification.comment}</div>
                  </Col>
                }
                {
                  selectedInvoiceForVerification.action_by && <Col>
                    <Label className="invoice-label-right">Action By</Label>
                    <div className="invoice-value-right">{selectedInvoiceForVerification.action_by}</div>
                  </Col>
                }
              </Row>
            }

            <Row className="c-top-25">
              <Col xl="8" md="8" xs="12" sm="12">
                <table className="table table-bordered table-responsive">
                  <thead id="wc-table-head" className="offtake-check-table-head">
                    <tr>
                      <th>Product Description</th>
                      <th>Qty</th>
                    </tr>
                  </thead>
                  <tbody id="wc-table-body">
                    {
                      (selectedInvoiceForVerification.product || []).map((item) => {
                        return (
                          <tr>
                            <td>
                              {item.description.name}
                            </td>
                            <td>
                              {item.quantity}
                            </td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>
              </Col>
            </Row>

            <br />
            
          <>
            <Row style={{ marginTop: '15px' }}>
              <Col className="fm-instruction">
                Note: Click on image to view larger image.
              </Col>
            </Row>
          </>

          <Row>
          {
            selectedInvoiceForVerification.invoice_url.map((uploadedFileData, index) => (
              uploadedFileData.url ?
                <>
                  {
                    uploadedFileData.type === 'pdf' &&
                    <>
                      <Col xl="3" md="3" sm="6" xs="12" id='pdf-disp' style={{ marginTop: '20px', paddingRight: '10px', paddingLeft: '10px' }}>
                        <div style={{ border: '1px solid #b9b7b7', borderRadius: '20px', height: '140px', textAlign: 'center' }}>

                          <img src="images/delete.svg" className="cursor-pointer edit-delete-icon"
                            onClick={() => this.props.deleteInvoice(uploadedFileData)}
                            alt='delete'
                            style={this.props.from === ''? { 'marginLeft': '86px' } : { 'marginLeft': '86px', 'visibility': 'hidden' }} />

                          <Document
                            file={uploadedFileData.url}
                            onLoadSuccess={this.onDocumentLoadSuccess}
                            loading="Loading..."
                            onClick={() => this.openViewModal(uploadedFileData)}
                          // className="react-pdf"
                          >
                            <Page pageNumber={pageNumber} width="80" scale={scale} />
                          </Document>

                        </div>
                      </Col>
                    </>
                  }

                  {
                    uploadedFileData.type !== 'pdf' &&
                    <>
                      <Col xl="3" md="3" sm="6" xs="12" style={{ overflow: 'auto', marginTop: '20px', paddingRight: '10px', paddingLeft: '10px' }}>

                        <div style={{ border: '1px solid #b9b7b7', borderRadius: '20px', height: '140px', textAlign: 'center' }}>

                          <img src="images/delete.svg" className="cursor-pointer edit-delete-icon"
                            onClick={() => this.props.deleteInvoice(uploadedFileData)}
                            alt='delete'
                            style={this.props.from === '' ? { 'marginLeft': '86px' } : { 'marginLeft': '86px', 'visibility': 'hidden' }} />

                          <img src={uploadedFileData.url} alt={uploadedFileData.name} width={100} height={100} className="img-viewer" onClick={() => this.openViewModal(uploadedFileData)} />

                        </div>

                      </Col>
                    </>
                  }
                </>
                :
                ''
            ))
          }
        </Row>

        <ImageAndPDFViewer
          title="Invoice"
          ref="openViewModal"
        />

          {/* {
           selectedInvoiceForVerification.invoice_url.map((data, index) => (
            <>
              {

                data.type === 'pdf' &&
                <>
                  <Row>
                    <Col>
                      <div className="pull-right">
                        <FontAwesomeIcon onClick={this.zoomInPDF} icon={faPlusCircle} style={{ fontSize: '20px', cursor: 'pointer' }} color="#fdbb1f" />
                        &nbsp;&nbsp;
                        <FontAwesomeIcon onClick={this.zoomOutPDF} icon={faMinusCircle} style={{ fontSize: '20px', cursor: 'pointer' }} color="#fdbb1f" />
                      </div>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '12px', overflow: 'auto' }}>
                    <Col>
                      <Document
                        file={data.url}
                        onLoadSuccess={this.onDocumentLoadSuccess}
                        loading="Loading..."
                        className="react-pdf"
                      >
                        <Page pageNumber={pageNumber} width="500" height="500" scale={scale} />
                      </Document>
                    </Col>
                  </Row>
                </>
              }

              {
                data.type !== 'pdf' &&
                <>
                  <Row>
                    <Col>
                      <div className="pull-right">
                        <FontAwesomeIcon onClick={this.zoomInImage} icon={faPlusCircle} style={{ fontSize: '20px', cursor: 'pointer' }} color="#fdbb1f" />
                        &nbsp;&nbsp;
                        <FontAwesomeIcon onClick={this.zoomOutImage} icon={faMinusCircle} style={{ fontSize: '20px', cursor: 'pointer' }} color="#fdbb1f" />
                      </div>
                    </Col>
                  </Row>
                  <Row style={{ overflow: 'auto', maxWidth: '570px' }}>
                    <Col>
                      <img src={data.url} alt={data.name} width={imageWidth} height={imageHeight} className="img-viewer" />
                    </Col>
                  </Row>
                </>
              }
            </>
          ))} */}

          </>
        }
      </div>
    );
  }
}

export default InvoiceVerificationDetail;